import React from "react";
import UpcomingInstallmentListingWrapper from "./UpcomingInstallments/List/UpcomingInstallmentListingWrapper";
import PaymentHistoryListingWrapper from "./PaymentHistory/List/PaymentHistoryListingWrapper";

type Props = {};

const StudentPaymentLayout = (props: Props) => {
  return (
    <div className="h-full flex flex-col gap-6 ">
      {/* Upcoming Installments */}
      <div className="">
        <UpcomingInstallmentListingWrapper />
      </div>

      <div className="max-h-[calc(100%-308px)]">
        <PaymentHistoryListingWrapper />
      </div>

      {/* Payments */}
    </div>
  );
};

export default StudentPaymentLayout;
